import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActivityIndicator } from '@ui/components/common/micro-interactions';
import { sumRegisteredHours } from '../../registered-hours';
import { Alert, Button, Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { CloseCircle } from 'iconsax-react';
import { WidgetHeader } from '../../../../../components/common/header/widgetHeader/WidgetHeader';
import { QInput } from '../../../../../components/common/inputs/QInput';
import { black500, black400 } from '../../../../../constants/color';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { DownloadAction } from '../../../../../components/common/actions/DownloadAction';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '@application/store/useStore';
import { getHoursByTimeSheetIds, updateTimeSheetAndHourRegistrationStatus } from '@application/features/HoursRegistration/hoursRegistrationThunk';
import { downloadCOCDocumentAsync } from '@application/features/freelancer/freelancerThunks';
import { convertBase64toBlob, getMimeTypeFromBase64, openOrDownloadPdf } from '@application/common/helpers/file-helper';
import { HoursStatus } from '@application/common/enums/hours-status';
import { ConfirmationDialog } from '../../all-user-hours/dialog/ConfirmationDialog';
import { DiclinedDialog } from './DiclinedDialog';
import React from 'react';
export const OpenTimesheetDialog = ({ open, handleClose, timeSheetIds, onActionComplete, clientName, monthAndYear }) => {
    const dispatch = useAppDispatch();
    const [hourAndTimeSheetDetail, setHourDetailAndTimeSheetDetail] = useState(null);
    const [timeSheetDocument, setTimeSheetDocument] = useState(null);
    const [totalNoOfHours, settotalNoOfHours] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
    const [declinedDialogOpen, setDeclinedDialogOpen] = useState(false);
    useEffect(() => {
        let active = true;
        setHourDetailAndTimeSheetDetail(null);
        setTimeSheetDocument(null);
        settotalNoOfHours(null);
        setLoadError(null);
        setConfirmationDialogOpen(false);
        setDeclinedDialogOpen(false);
        setIsLoading(!!timeSheetIds && open);
        if (timeSheetIds && open) {
            dispatch(getHoursByTimeSheetIds(timeSheetIds)).unwrap().then(resp => {
                if (!active)
                    return;
                setHourDetailAndTimeSheetDetail(resp);
                setTimeSheetDocument(resp.map(ts => ts.timeSheetDocumentDto).find(doc => doc?.id && doc.id !== '00000000-0000-0000-0000-000000000000') ?? null);
                settotalNoOfHours(sumRegisteredHours(resp));
            }).catch(() => { if (active)
                setLoadError('Unable to load these hours. Close this dialog and try again.'); })
                .finally(() => { if (active)
                setIsLoading(false); });
        }
        return () => { active = false; };
    }, [dispatch, open, timeSheetIds]);
    const sumFilteredHours = sumRegisteredHours;
    const convertUrlFileToPDF = (timeSheetDocument) => {
        const fileDto = { folderName: timeSheetDocument?.folderName, fileName: timeSheetDocument?.name };
        dispatch(downloadCOCDocumentAsync(fileDto))
            .unwrap()
            .then((res) => {
            const mimeType = getMimeTypeFromBase64(res.file);
            if (mimeType === 'application/pdf') {
                openOrDownloadPdf(res.file, timeSheetDocument?.name ?? 'document', 'Chamber of Commerce Document');
            }
            else {
                const blob = convertBase64toBlob(res.file, mimeType ?? '');
                if (!blob) {
                    console.error('Failed to create Blob from the base64 string.');
                    return;
                }
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = timeSheetDocument?.name || 'download';
                link.click();
                URL.revokeObjectURL(url);
            }
        })
            .catch(() => { });
    };
    const renderInputRow = (weeklyHourDetail) => (_jsx(_Fragment, { children: _jsxs(Grid, { container: true, columnSpacing: 2, rowSpacing: 2, mt: '0.2px', children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: "Date" }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: "Registration" }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: "Register" }) }), weeklyHourDetail.weeklyHourRegistrations.map((weeklyDetails, index) => (_jsx(React.Fragment, { children: weeklyDetails.hourRegistrations.map((hourDetail, hourIndex) => (_jsxs(React.Fragment, { children: [_jsx(Grid, { item: true, xs: 3, children: _jsx(Box, { sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%'
                                    }, children: _jsx(Typography, { variant: 'subtitle2', color: black400, fontSize: { xs: '11px', md: '14px' }, children: new Date(hourDetail.date).toLocaleDateString('en-GB') }) }) }), _jsx(Grid, { item: true, xs: 6, children: _jsx(QInput, { fillBackground: true, placeholder: 'Client', disabled: true, value: hourDetail.clientName, onChange: () => { } }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(QInput, { disabled: true, fillBackground: true, placeholder: '0', value: hourDetail.noOfHours, onChange: () => { } }) })] }, hourIndex))) }, index)))] }) }));
    const handleApprove = () => {
        setConfirmationDialogOpen(true);
    };
    const handleDeclinePopup = () => {
        setDeclinedDialogOpen(true);
    };
    const handleConfirmApproval = () => {
        if (timeSheetIds && hourAndTimeSheetDetail) {
            const timeSheetDto = {
                status: HoursStatus.Approved,
                timeSheetIds: timeSheetIds
            };
            updateTimeSheetAndHourRegistrationStatusWrapper(timeSheetDto);
        }
    };
    const handleConfirmDecline = (reason) => {
        if (timeSheetIds && hourAndTimeSheetDetail) {
            const timeSheetDto = {
                status: HoursStatus.Rejected,
                timeSheetIds: timeSheetIds,
                reason: reason
            };
            updateTimeSheetAndHourRegistrationStatusWrapper(timeSheetDto);
        }
    };
    const updateTimeSheetAndHourRegistrationStatusWrapper = (timeSheetDto) => {
        dispatch(updateTimeSheetAndHourRegistrationStatus(timeSheetDto))
            .unwrap()
            .then(() => {
            onActionComplete();
            setConfirmationDialogOpen(false);
            handleClose();
        })
            .catch((error) => { });
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, PaperProps: {
            sx: {
                width: '620px',
                maxHeight: { xs: '90svh', md: '80svh' },
                overflow: 'hidden'
            }
        }, children: [_jsxs(Box, { style: { position: 'relative', paddingBottom: '72px' }, children: [_jsx(Box, { sx: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            backgroundColor: 'white'
                        }, children: _jsxs(WidgetHeader, { background: 'white', children: [_jsxs(Typography, { fontSize: '20px', color: 'black', children: [clientName, " - ", monthAndYear] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }) }), _jsx(Box, { sx: {
                            padding: { xs: '25px' },
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: { xs: 'calc(90svh - 190px)', md: 'calc(90svh - 250px)' },
                            minWidth: '320px'
                        }, children: _jsxs(Box, { pb: { xs: 7, md: 2 }, children: [isLoading && _jsx(ActivityIndicator, { label: 'Loading registered hours\u2026', announce: true }), loadError && _jsx(Alert, { severity: 'error', children: loadError }), _jsxs(Grid, { width: '100%', container: true, children: [hourAndTimeSheetDetail &&
                                            hourAndTimeSheetDetail.map((record) => (_jsx(Grid, { item: true, xs: 12, children: _jsx(_Fragment, { children: renderInputRow(record) }) }))), _jsx(Grid, { item: true, md: 12, children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    gap: { xs: 1, md: 2 },
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    paddingTop: 3
                                                }, children: [_jsx(Typography, { variant: 'subtitle2', color: 'initial', children: "Registered hours" }), _jsx(Box, { width: { xs: 200, md: 240 }, children: _jsx(QInput, { value: totalNoOfHours ?? '—', disabled: true }) })] }) })] })] }) }), _jsx(Box, { py: 2, px: 2, borderTop: '1px solid #D7D7D7', position: 'absolute', bottom: 0, left: 0, right: 0, bgcolor: 'white', children: _jsxs(Grid, { container: true, spacing: 2, position: 'sticky', alignItems: 'center', children: [_jsx(Grid, { item: true, xs: 6, md: 2, children: _jsx(Typography, { variant: 'subtitle2', color: '#555555', children: "Hours approval client" }) }), _jsx(Grid, { item: true, xs: 6, md: 4, children: timeSheetDocument && (_jsx(DownloadAction, { fileName: timeSheetDocument?.name ?? '', type: 'download', width: '100%', onClick: () => {
                                            if (timeSheetDocument) {
                                                convertUrlFileToPDF(timeSheetDocument);
                                            }
                                            else {
                                                return;
                                            }
                                        } })) }), _jsx(Grid, { item: true, xs: 6, md: 4, children: _jsx(PrimaryButon, { disabled: isLoading || !!loadError || totalNoOfHours === null, onClick: handleApprove, children: "Approve" }) }), _jsx(Grid, { item: true, xs: 6, md: 2, children: _jsx(Button, { color: 'error', disabled: isLoading || !!loadError || totalNoOfHours === null, onClick: handleDeclinePopup, children: "Decline" }) })] }) })] }), _jsx(ConfirmationDialog, { open: confirmationDialogOpen, handleClose: () => setConfirmationDialogOpen(false), onConfirm: handleConfirmApproval, title: 'Are you sure want to approve these hours ?', subTitle: '' }), _jsx(DiclinedDialog, { open: declinedDialogOpen, handleClose: () => setDeclinedDialogOpen(false), onConfirm: handleConfirmDecline })] }));
};
